export default "__VITE_PUBLIC_ASSET__9278595f__"